import type { LookupDataItem } from '../grid/types';
import {
  INVOICE_BANK_BY_CURRENCY_JS_METHOD,
  resolveDefaultInvoiceBankId,
} from './invoiceBankOptions';

type DetailFormLookupDefaultResolver = (items: LookupDataItem[] | undefined) => string | null;

const detailFormLookupDefaultResolvers: Record<string, DetailFormLookupDefaultResolver> = {
  [INVOICE_BANK_BY_CURRENCY_JS_METHOD]: resolveDefaultInvoiceBankId,
};

export const getDetailFormJsMethodDefaultLookupId = (
  name: string | null | undefined,
  items: LookupDataItem[] | undefined
): string | null => {
  const resolver = name ? detailFormLookupDefaultResolvers[name.trim()] : undefined;
  return resolver?.(items) ?? null;
};
